module.exports = __webpack_public_path__ + "img/9788988537930.698e5608.jpg";